import { useLocation } from 'wouter';
import { useClubSummary } from './http/use-club-summary';

/**
 * Rotas de primeiro nível que não são slug de loja (ver `src/main.tsx`).
 */
const NON_STORE_SEGMENTS = new Set([
  'search',
  'profile',
  'indicacao',
  'orders',
  'cart',
  'auth',
  'login-by-link',
  'entrar',
  'sentry-test',
  'error-boundary-test',
]);

/**
 * Loja em uso para a barra inferior. A barra fica fora das rotas, então o
 * `useParams` dela vem vazio: a slug sai do caminho atual (`/{slug}/...`) e,
 * fora das páginas de loja (busca, perfil, pedidos), da última loja aberta.
 */
export function getTabStoreSlug(location: string): string {
  const [first] = location.split('?')[0].split('/').filter(Boolean);
  const segment = first ? decodeURIComponent(first) : '';

  if (segment && segment !== 'undefined' && !NON_STORE_SEGMENTS.has(segment)) {
    return segment;
  }

  try {
    const stored = sessionStorage.getItem('store-slug');
    return stored && stored !== 'undefined' ? stored : '';
  } catch {
    return '';
  }
}

/**
 * Diz se a aba "Clube pratiGO" entra na barra inferior: só quando a loja em
 * uso tem o programa ativo no gestor.
 */
export function useClubTab() {
  const [location] = useLocation();
  const slug = getTabStoreSlug(location);
  const summaryQuery = useClubSummary(slug, { enabled: !!slug });

  return {
    slug,
    isVisible: Boolean(slug && summaryQuery.data?.enabled),
    availablePoints: summaryQuery.data?.customer?.available_points ?? null,
  };
}
